export enum EmailIntegrationProvider {
    Google = 'google',
    Imap = 'imap',
    Microsoft = 'microsoft',
    Icloud = 'icloud',
    VirtualCalendar = 'virtual-calendar',
}
